<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaAngajat')}} </h4>
        </div>
        <form class="add-user-form" id="add-partner">
            <div class="type-person">
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.tipulDePersoana')}} </h4>
                    </div>
                    <div class="col-12">
                        <label class="container_check">
                            <input type="radio" value="1" name="type" v-model="personType">
                            <span class="checkmark"></span>
                            {{$t('txt.persFizica')}}
                        </label>
                    </div>
                    <div class="col-12">
                        <label class="container_check">
                            <input type="radio" value="2" name="type" v-model="personType">
                            <span class="checkmark"></span>
                            {{$t('txt.persJuridica')}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                         <div class="inputfield-wrapper" v-if="!input_field.personType || parseInt(input_field.personType) === parseInt(personType)">
                           <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :data-vv-as="input_field.labelName"
                                   v-bind:name="input_field.inputName"
                                   v-bind:id="input_field.inputName">
                           <label class=""> {{input_field.labelName}} </label>
                           <span class="focus-input"></span>
                           <span class="symbol-input">
                             <i v-bind:class="input_field.icon"></i>
                           </span>
                         </div>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.judet')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_county" :options="counties" label="name"
                                      @input="getCitiesByCounty()"></v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 2">
                            <label :class="{select_label_class:selected_label === 2}"> {{$t('placeholder.oras')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 2}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_city" :options="cities" label="name"></v-select>
                        </div>
                        <div v-else>
                            <input type="text"
                                   class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :data-vv-as="input_field.labelName"
                                   :name="input_field.inputName"
                                   :id="input_field.inputName">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                                <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                            <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                        </div>
                    </div>
                </div>
                <div class="alert-checkbox-container">
                    <label class="alert-checkbox" for="create-check">
                        <input type="checkbox" value='1' name="create_account" id="create-check">
                        <span class="checkbox-material">
                            <span class="check"></span>
                        </span>
                        <p> {{$t('txt.creeazaCont')}} </p>
                    </label>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.selecteazaTipAngajat')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                   <subtypes :subtypes="employeeSubtypes"></subtypes>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.depozite')}} </h4>
                    </div>
                </div>
                <warehouses :select="this.warehouses"></warehouses>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.documente')}} </h4>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.roluri')}} </h4>
                    </div>
                </div>
                <roles :roles="roles" :type="'employee'"/>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.documente')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div class="inner-location-group doc-group">
                        <b-form-file
                                name="files[]"
                                v-model="file"
                                ref="file-input"
                                :state="Boolean(file)"
                                :placeholder="$t('placeholder.dropFileHere')"
                                :drop-placeholder="$t('placeholder.dropFileHere')"
                                multiple
                        ></b-form-file>
                        <div class="reset-files-wrapper" v-if="file">
                            <b-button @click="clearFiles" class="reset-files-button"> {{$t('txt.eliminaFisiereleIncarcate')}}
                            </b-button>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea :placeholder="$t('placeholder.notite')" name='notes'></textarea>
                        <div class="save-contact-buttons">
                            <button @click.prevent='addEmployee()' :disabled="this.$store.state.loading">
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import EmployeesService from '../../api-services/employees.service'
import CountiesService from '../../api-services/counties.service.js'
import RolesService from '../../api-services/roles.service.js'
import Subtypes from '../subtypes/Subtypes.vue'
import Warehouses from '../warehouse/Warehouse.vue'
import Roles from '../../components/Roles.vue'
import { syncPartners } from '../../sync/sync'
export default {
  name: 'addemployees',
  data () {
    return {
      personType: 1,
      selected_label: null,
      file: null,
      counties: [],
      cities: [],
      select_county: null,
      select_city: null,
      input_fields: {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: null,
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: null,
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: null,
            icon: 'far fa-id-card',
            validationRules: 'min:13|max:13|numeric',
            personType: 1
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            inputValue: null,
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            inputValue: null,
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: null,
            icon: 'fas fa-building',
            validationRules: 'required',
            personType: 2
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: null,
            icon: 'fas fa-phone',
            validationRules: ''
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: null,
            icon: 'fas fa-scroll',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: null,
            icon: 'fas fa-cash-register',
            validationRules: '',
            personType: 2
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: null,
            icon: 'fas fa-piggy-bank',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: null,
            icon: 'fas fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'delegat',
            labelName: this.$t('placeholder.delegat'),
            inputValue: null,
            icon: 'fas fa-user-tie',
            validationRules: ''
          },
          {
            inputName: 'date_corespondenta',
            labelName: this.$t('placeholder.dateDeCorespondenta'),
            inputValue: null,
            icon: 'fas fa-info',
            validationRules: ''
          },
          {
            inputName: 'site',
            labelName: this.$t('placeholder.siteWeb'),
            inputValue: null,
            icon: 'far fa-window-maximize',
            validationRules: ''
          }
        ],
        location: [
          {
            inputName: 'location_name',
            labelName: this.$t('placeholder.denumireLocatie'),
            inputValue: null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'location_address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'location_link_map',
            labelName: this.$t('placeholder.linkGoogleMaps'),
            inputValue: null,
            icon: 'fas fa-map-marked',
            validationRules: ''
          },
          {
            inputName: 'location_pers_contact',
            labelName: this.$t('placeholder.persoanaContact'),
            inputValue: null,
            icon: 'fas fa-users-cog',
            validationRules: ''
          }
        ],
        contact: [
          {
            inputName: 'contact_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: null,
            icon: 'fas fa-signature',
            validationRules: ''
          },
          {
            inputName: 'contact_phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: null,
            icon: 'fas fa-phone',
            validationRules: ''
          },
          {
            inputName: 'contact_email',
            labelName: this.$t('placeholder.email'),
            inputValue: null,
            icon: 'fa fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'contact_function',
            labelName: this.$t('placeholder.functie'),
            inputValue: null,
            icon: 'far fa-id-badge',
            validationRules: ''
          }
        ]
      },
      employeeSubtypes: [],
      warehouses: [],
      roles: []
    }
  },
  components: {
    'subtypes': Subtypes,
    'warehouses': Warehouses,
    'roles': Roles
  },
  methods: {
    getRoles () {
      RolesService.getAll()
        .then((response) => {
          this.roles = response.data.data
          // employee default - look in mixins
          this.checkUserDefaultRole(this.roles, 'employee')
        })
        .catch((error) => {
          console.log(error)
        })
    },
    clearFiles () {
      this.$refs['file-input'].reset()
    },
    getWarehouses () {
      EmployeesService.getWarehouses()
        .then((response) => {
          this.warehouses = response.data.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCounties () {
      CountiesService.getAll({ per_page: -1 })
        .then((response) => {
          this.counties = response.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCitiesByCounty () {
      let countyId = (this.select_county) ? this.select_county.id : null
      this.cities = []
      this.select_city = null
      if (countyId && countyId > 0) {
        CountiesService.get(countyId)
          .then((response) => {
            this.cities = response.data.data.cities
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getEmployeeSubtypes () {
      EmployeesService.getTypes()
        .then((response) => {
          this.employeeSubtypes = response.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async addEmployee () {
      let validatorResp = true
      await this.$validator.validateAll().then((result) => {
        validatorResp = result
        if (this.$validator.errors && !result) {
          let input = document.getElementById(this.$validator.errors.items[0].field)
          window.scrollTo(0, input.offsetTop - 50)
        }
      })
      if (!validatorResp) {
        return
      }
      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      let formData = new FormData(document.getElementById('add-partner'))
      if (this.select_county) {
        formData.append('county', this.select_county.id)
      }
      if (this.select_city) {
        formData.append('city', this.select_city.id)
      }

      let roleId = this.roles.filter(function (role) {
        if (role.value) {
          return role.name
        }
      })
      formData.append('roles', JSON.stringify(roleId))
      formData.append('subtypes', JSON.stringify(this.employeeSubtypes))
      formData.append('warehouses', JSON.stringify(this.warehouses))

      EmployeesService.create(formData)
        .then((response) => {
          syncPartners()
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.angajatAdaugat'),
            'animation-type': 'css'
          })
          // var frm = document.getElementById('test-id')
          // alert(frm.offsetTop)
          window.scrollTo(0, 0)
          this.$router.push({ name: 'employees' })
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  computed: {},
  created () {
    this.getRoles()
    this.getCounties()
    this.getEmployeeSubtypes()
    this.getWarehouses()
    this.$store.dispatch('hideLoading')
  }
}
</script>
